
























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import constants from "../store/constants";
import anime, { AnimeInstance, easings } from "animejs";
import Swiper from "swiper";
import BackgroundLines from "./BackgroundLines.vue";
import Viewer from "viewerjs";

@Component({
  components: {
    BackgroundLines
  }
})
export default class SingleVideoWindow extends Vue {
  @State(state => state.app.activeVideo) activeVideo!: string;

  $refs!: {
    root: HTMLElement;
    content: HTMLElement;
    container: HTMLElement;
  };

  active = false;
  playing = false;
  player: any = null;

  close() {
    this.$store.dispatch(constants.showVideo, "");
  }

  mounted() {
    window.addEventListener("keydown", (e: KeyboardEvent) => {
      if (this.active && e.keyCode == 27) {
        this.close();
      }
    });
  }

  @Watch("activeVideo")
  contentChange(newValue: string, oldValue: string) {
    let _t = this;

    var onPlayerReady = (event: any) => {
      event.target.playVideo();
      this.playing = true;
    };

    var onPlayerStateChange = (event: any) => {
      let YT = (<any>window).YT;
      if (event.data == YT.PlayerState.ENDED) {
        _t.$store.dispatch(constants.showVideo, "");
        this.playing = false;
      }

      if (event.data == YT.PlayerState.PAUSED) {
        this.playing = false;
      }

      if (event.data == YT.PlayerState.PLAYING) {
        this.playing = true;
      }
    };

    let setPlayer = () => {
      let YT = (<any>window).YT;
      this.player = new YT.Player("svw-video-player", {
        height: "100%",
        width: "100%",
        videoId: newValue,
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange
        }
      });
    };

    (<any>window).onYouTubeIframeAPIReady = () => {
      setPlayer();
    };

    if (newValue.length == 0) {
      if (this.playing) this.player.pauseVideo();
      this.closeWindowHandler();
      this.playing = false;
      return;
    }

    if (oldValue.length == 0 && newValue.length > 0) {
      if (this.player == null) {
        if ((<any>window).YT == null) {
          var tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          document.body.insertBefore(tag, document.body.children[0]);
        } else {
          (<any>window).onYouTubeIframeAPIReady();
        }
      }

      this.openWindowHandler();
    }
  }

  openWindowHandler() {
    this.active = true;
    setTimeout(() => {
      this.$refs.container.classList.add("showed");
    }, 50);
  }

  closeWindowHandler() {
    this.$refs.container.classList.remove("showed");
    setTimeout(() => {
      this.active = false;
    }, 850);
  }
}
